import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { sortBy, toLower } from 'lodash';

import {
  routines as decisionsActions,
  isDealsForGpListLoadingSelector,
  dealsForGpListSelector,
  isSectionsLoadingSelector,
  sectionListSelector
} from '../../reducers/db/decisions';
import './style.css';

class ChangeDeal extends Component {
  static propTypes = {
    className: PropTypes.string
  };
  static defaultProps = {
    className: ''
  };

  componentDidMount() {
    const gpemail = window.localStorage.getItem('active-user-id');
    this.props.getDealsForGpList({ email: gpemail });
    this.props.getSections();
  }

  handleClick = dealId => {
    // set dealId in local storage
    window.localStorage.setItem('dealId', dealId);
    const { sectionList } = this.props;
    if (sectionList[0].length > 0) {
      window.localStorage.setItem('section', sectionList[0][0].entityName);
    }
    setTimeout(() => {
      window.location.href = '/dashboard';
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }, 0);
  };
  render() {
    const { className, dealId, dealsForGpList } = this.props;
    const classList = classNames('change-client-view', className);
    return (
      <div className={classList}>
        <div className="change-client-view-title">
          <i className="fas fa-building change-client-view-title-icon" />
          <span className="change-client-view-title-label">
            {dealId ? 'Change' : 'Choose'} Deal
          </span>
        </div>

        <div className="change-client-view-list">
          {dealsForGpList.length === 0 && (
            <div className="change-client-view-empty">No Deals Assigned</div>
          )}
          {sortBy(dealsForGpList.dealsForGpList, item =>
            toLower(item.name)
          ).map(deal => (
            <div
              className="change-client-view-list-item"
              key={deal.salesforceDealID}
              onClick={() => this.handleClick(deal.salesforceDealID)}>
              <span className="change-client-view-list-item-label">
                {deal.fundName}
              </span>
              {dealId === deal.salesforceDealID && (
                <div className="change-client-view-list-item-active">
                  Active
                </div>
              )}
              <i className="change-client-view-list-item-icon fas fa-chevron-right" />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

const makeMapStateToProps = () => {
  const mapStateToProps = (state, props) => {
    return {
      isDealsForGpListLoading: isDealsForGpListLoadingSelector(state, props),
      dealsForGpList: dealsForGpListSelector(state, props),
      sectionListLoading: isSectionsLoadingSelector(state, props),
      sectionList: sectionListSelector(state, props)
    };
  };
  return mapStateToProps;
};

const mapDispatchToProps = {
  getDealsForGpList: decisionsActions.getDealsForGpList,
  getSections: decisionsActions.getSections
};

export default connect(makeMapStateToProps, mapDispatchToProps)(ChangeDeal);
